<template>
  <div>
    <div class="application__steps">
      <div class="container">
        <ul>
          <li :class="{ active: step >= 1, current: step === 1 }">
            Step 1
          </li>
          <li :class="{ active: step >= 2, current: step === 2 }">
            Step 2
          </li>
          <li :class="{ active: step >= 3, current: step === 3 }">
            Step 3
          </li>
        </ul>
      </div>
    </div>

    <div class="application__form">
      <div class="container">
        <Error :message="error" />

        <div v-if="step === 1" class="step step__one">
          <form @submit.prevent="changeStep(2)">
            <p class="title">
              Are you a homeowner?
            </p>

            <ul>
              <li>
                <input
                  id="step-1-homeowner-yes"
                  v-model="data.homeowner"
                  class="styled-checkbox"
                  type="radio"
                  name="step-1-homeowner"
                  :value="true"
                />
                <label for="step-1-homeowner-yes">Yes</label>
              </li>
              <li>
                <input
                  id="step-1-homeowner-no"
                  v-model="data.homeowner"
                  class="styled-checkbox"
                  type="radio"
                  name="step-1-homeowner"
                  :value="false"
                />
                <label for="step-1-homeowner-no">No</label>
              </li>
            </ul>

            <p class="title">
              How Old Is Your Current Boiler?
            </p>

            <ul>
              <li v-for="(item, index) in boilerOptions" :key="item">
                <input
                  :id="`step-1-boilerAge-${index}`"
                  v-model="data.boilerAge"
                  class="styled-checkbox"
                  type="radio"
                  name="step-1-boilerAge"
                  :value="item"
                />
                <label :for="`step-1-boilerAge-${index}`">{{ item }}</label>
              </li>
            </ul>

            <p class="title">
              Are you or anyone in your household in receipt of benefits. You
              only need to select one.
            </p>

            <ul>
              <li v-for="(item, index) in receiptOptions" :key="item">
                <input
                  :id="`step-1-check-${index}`"
                  v-model="data.receiptOf"
                  class="styled-checkbox"
                  type="radio"
                  :value="item"
                />
                <label :for="`step-1-check-${index}`">{{ item }}</label>
              </li>
            </ul>

            <div class="buttons">
              <button class="btn btn-primary btn-next applicationSubmit1">
                NEXT
              </button>
            </div>
          </form>
        </div>

        <div v-if="step === 2" class="step step__two">
          <div class="text-left">
            <button class="go-back" @click="changeStep(1)">
              « Go back
            </button>
          </div>
          <p v-if="qualify" class="title">
            Your Grant Application
            <small class="title-disclaimer">(we DON'T sell your data)</small>
          </p>
          <p v-else class="title">
            You may be entitled to a discounted boiler
          </p>

          <form @submit.prevent="changeStep(3)">
            <template v-if="version === 'v1'">
              <div class="title">
                <p>What type of property are you applying for?</p>
              </div>

              <div class="form-group">
                <select
                  v-model="data.propertyType"
                  class="form-control custom-select"
                  required
                >
                  <option value="" disabled hidden>
                    Please Select
                  </option>
                  <option>Detached House</option>
                  <option>Semi-Detached House</option>
                  <option>End-Terrace House</option>
                  <option>Mid-Terrace House</option>
                  <option>Bungalow</option>
                  <option>Park Home</option>
                </select>
              </div>
            </template>

            <div class="title">
              <p>Contact Details</p>
            </div>

            <div class="form-group">
              <input
                v-model="data.fullName"
                type="text"
                class="form-control"
                placeholder="Full Name"
                minlength="2"
                pattern=".{2,}"
                required
                title="2 characters minimum"
              />
            </div>

            <div class="form-group">
              <input
                v-model="data.email"
                type="email"
                class="form-control"
                placeholder="Email Address"
                required
              />
            </div>

            <div class="form-group">
              <input
                v-model="data.phone"
                type="tel"
                class="form-control"
                placeholder="Phone Number"
                minlength="7"
                pattern="(?:\+?44)[0-9]{9}|(?:0)[0-9]{10}"
                required
                title="has to start with 0 or +44 and contain 9-10 numbers"
              />
            </div>

            <div class="form-group">
              <input
                v-model="data.postcode"
                type="text"
                class="form-control"
                placeholder="Postcode"
                pattern="([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})"
                title="UK Postcode"
                required
              />
            </div>

            <div class="checkbox">
              <label>
                <input type="checkbox" name="terms" checked required /> I agree
                with Lead Monster Ltd.’s
                <a href="/privacy-policy" target="_blank">Privacy Policy</a>
              </label>
            </div>

            <button
              :class="[
                { qualify, 'not-qualify': !qualify },
                'btn btn-primary btn-next applicationSubmit2'
              ]"
            >
              Check If You Qualify
            </button>
          </form>
        </div>

        <div v-if="step === 3" class="step step__three">
          <div class="row">
            <div class="col-sm-12">
              <p
                :class="[
                  { qualify, 'not-qualify': !qualify },
                  'result text-29 text-bold'
                ]"
              >
                <img
                  :src="`${window.themeUrl}/static/vectors/check-orange.svg`"
                />
                <span v-if="qualify">You Qualify for a Grant!</span>
                <span v-else>You qualify for a discounted boiler!</span>
              </p>

              <ol>
                <li>You’ll be contacted within 24 hours</li>
                <li>A free home survey will be booked</li>
                <li>Get referred & get your boiler installed</li>
                <li>You’ll enjoy a happier, warmer home</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmoothScroll from "smooth-scroll"
import Error from "./components/Error.vue"

export default {
  components: { Error },
  props: {
    resultPage: {
      type: String,
      default: null
    },
    version: {
      type: String,
      default: "v1"
    }
  },
  data() {
    return {
      step: 1,
      receiptOptions: [
        "Universal Credit",
        "Pension Credit",
        "ESA",
        "JSA",
        "Income Support",
        "Working Tax Credits",
        "Child Tax Credits",
        "AFIP",
        "Attendance Allowance",
        "Carer's Allowance",
        "DLA",
        "PIP",
        "War Pensions Mobility Supplement",
        "Severe Disablement Allowance",
        "Industrial Injuries Disablement Benefit",
        "Constant Attendance Allowance",
        "Child Benefits"
      ],
      boilerOptions: [
        "Less Than 8 Years Old",
        "8-15 Years Old",
        "15+ Years Old",
        "I DON'T Have A Boiler"
      ],
      bedroomRadioboxes: [1, 2, 3, 4, 5, "6+"],
      data: {
        ppc: false,
        homeowner: null,
        receiptOf: null,
        boilerType: "",
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        houseNumber: null,
        postcode: null,
        propertyType: "",
        bedrooms: null,
        boilerAge: "8-15 Years Old"
      },
      error: "",
      sent: false,
      sending: false
    }
  },
  computed: {
    qualify() {
      return this.data.receiptOf === "Yes"
    },
    window() {
      return window.base
    },
    form() {
      return {
        data: this.data,
        qualify: this.qualify,
        action: "application_form"
      }
    }
  },

  mounted() {
    const searchParams = new URLSearchParams(window.location.search)

    searchParams.forEach((value, name) => {
      this.data[name] = value
    })

    if (this.data.receiptOf) {
      this.step = 2
    }

    if (!this.data.postcode) {
      window.location.href = "/"
    }
  },
  methods: {
    changeStep(step) {
      if (this.validate(step - 1)) {
        this.step = step
      }

      if (step === 3) {
        this.submit()

        if (this.resultPage) {
          this.step -= 1
          return null
        }
      }

      const scroll = new SmoothScroll()
      const section = document.querySelector(".application__form")

      scroll.animateScroll(section)

      return true
    },

    validate(step) {
      if (step === 1) {
        if (!this.data.receiptOf) {
          this.error = "Pick at least one box."
          return false
        }

        if (this.data.homeowner === null) {
          this.error = "Are you a homeowner?"
          return false
        }
      }

      this.error = ""
      return true
    },

    share(event) {
      const width = 575
      const height = 400
      const left = ($(window).width() - width) / 2
      const top = ($(window).height() - height) / 2
      const opts = `status=1,width=${width},height=${height},top=${top},left=${left}`

      window.open(event.target.href, "Share on Facebook", opts)

      return false
    },

    submit() {
      if (window.fbq) {
        window.fbq("track", "CompleteRegistration")
      }

      if (window.dataLayer) {
        window.dataLayer.push({ event: "lead" })
      }

      if (this.qualify) {
        if (window.fbq) {
          window.fbq("track", "Lead")
        }

        if (window.dataLayer) {
          window.dataLayer.push({ event: "lead-qualified" })
        }
      } else if (window.dataLayer) {
        window.dataLayer.push({ event: "lead-rejected" })
      }

      $.ajax({
        url: window.base.apiUrl,
        method: "POST",
        dataType: "json",
        data: this.form,
        success: () => {
          if (this.resultPage) {
            window.location.href = this.resultPage
          }
        },
        error: () => {
          alert("Something went wrong. Please try again.")
        }
      })
    },

    fakeSubmit() {
      this.sent = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap-sass/assets/stylesheets/bootstrap/variables";
@import "../../sass/common/variables";

.application {
  &__steps {
    padding: 30px 0 65px;
    color: #fff;
    background: #2c2c2c;

    ul {
      display: flex;
      padding: 0;
      margin: 0;
      list-style: none;
    }

    ul li {
      position: relative;
      flex: 1;
      text-align: center;
    }

    ul li:before {
      position: absolute;
      top: 30px;
      right: 0;
      left: 0;
      z-index: 2;
      display: block;
      width: 20px;
      height: 20px;
      margin: 0 auto 15px auto;
      content: "";
      background: #fff;
      border: 2px solid #fff;
      border-radius: 100%;
    }

    ul li:after {
      position: absolute;
      top: 38px;
      left: -50%;
      z-index: 1;
      display: block;
      width: 100%;
      height: 4px;
      content: "";
      background: #838383;
    }

    ul li:first-child:after {
      content: none;
    }

    ul li.current {
      font-weight: bold;
      color: #ff8e01;

      &::before {
        border-color: #ff8e01;
      }
    }

    ul li.active:after {
      background-image: linear-gradient(
        to right,
        rgb(255, 85, 2) 0%,
        rgb(255, 162, 0) 100%
      );
    }
  }

  &__form {
    padding: 50px 0;

    @media (max-width: $screen-xs-max) {
      padding: 30px 0;
    }

    .step {
      text-align: center;

      .title {
        margin-bottom: 35px;
        font-size: 24px;
        font-weight: bold;

        &:not(:first-child) {
          margin-top: 35px;
        }

        @media (max-width: $screen-xs-max) {
          margin-bottom: 20px;
          font-size: 24px;

          &:not(:first-child) {
            margin-top: 20px;
          }
        }

        .title-disclaimer {
          display: block;
          font-size: 1.8rem;
          color: #6b6b6b;
        }
      }

      .custom-label {
        margin-bottom: 25px;
        font-size: 22px;
        color: #6b6b6b;
      }

      .custom-label-big {
        margin-bottom: 25px;

        p:nth-child(1) {
          font-size: 26px;
          font-weight: bold;
          color: #323232;

          @media (max-width: $screen-xs-max) {
            font-size: 24px;
          }
        }

        p:nth-child(2) {
          margin-top: 10px;
          font-family: $font-book;
          font-size: 16px;
          color: #818181;

          @media (max-width: $screen-xs-max) {
            font-size: 16px;
          }
        }
      }

      .form-group {
        margin-bottom: 30px;

        @media (max-width: $screen-xs-max) {
          margin-bottom: 20px;
        }
      }

      .form-control {
        display: block;
        width: 100%;
        max-width: 500px;
        height: 50px;
        padding-left: 25px;
        margin-right: auto;
        margin-left: auto;
        font-family: $font-book;
        font-size: 18px;
        color: #606060;
        border: 2px solid #9e9e9e;
        border-radius: 6px;
        box-shadow: none;
      }

      &__one {
        ul {
          padding: 0;
          margin: 0;
          font-size: 0;
          color: #6b6b6b;
          list-style: none;

          li {
            display: inline-block;
            width: calc(50% - 30px);
            margin: 0 15px 20px;
            font-size: 18px;
            text-align: left;

            @media (max-width: $screen-xs-max) {
              width: 100%;
              margin: 0 0 20px;
            }

            label {
              display: block;
              padding: 12px 10px 10px;
              border: 2px solid #6b6b6b;
              border-radius: 6px;

              &::after {
                top: 16px;
                left: 18px;
              }
            }
          }
        }
      }

      &__three {
        text-align: left;

        .result {
          margin-bottom: 20px;

          img {
            width: 40px;
            height: 40px;
            margin-right: 5px;
          }

          * {
            vertical-align: middle;
          }
        }

        .notice {
          padding: 20px 25px;
          margin-top: 25px;
          font-family: $font-book;
          font-size: 14px;
          color: #323232;
          background: #feffe4;
          border: 2px solid $color-orange;
          border-radius: 6px;
        }

        ol {
          padding: 0;
          margin: 0;
          font-size: 20px;
          font-weight: bold;
          list-style: none;
          counter-reset: li;

          li {
            margin-bottom: 5px;
            counter-increment: li;

            &::before {
              display: inline-block;
              margin-right: 10px;
              color: $color-orange;
              text-align: right;
              content: counter(li);
              direction: rtl;
            }
          }
        }
      }
    }
  }
}

.btn-next {
  margin-top: 35px;

  @media (max-width: $screen-xs-max) {
    margin-top: 15px;
  }
}

.radio-buttons {
  margin: 25px 0 40px;

  @media (max-width: $screen-xs-max) {
    margin-bottom: 25px;
  }

  > div {
    display: inline-block;
    vertical-align: top;

    &:not(:last-child) {
      margin-right: 40px;

      @media (max-width: $screen-xs-max) {
        margin-right: 10px;
        margin-bottom: 5px;
      }
    }
  }
}

.facebook-share {
  @media (max-width: $screen-xs-max) {
    margin-top: 25px;
  }
  display: block;
  padding: 10px 15px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;

  background: #2e4d94;

  &:hover {
    text-decoration: none;
  }

  svg {
    width: 26px;
    height: 48px;
    margin-right: 5px;
  }

  svg,
  span {
    vertical-align: middle;
  }
}

.go-back {
  margin-bottom: 15px;
  color: $color-orange;
  background: transparent;
  border: 0;
  border-bottom: 1px solid $color-orange;
  border-radius: 0;
  transition: all 0.3s ease;

  &:hover {
    color: darken($color-orange, 15);
    border-bottom-color: darken($color-orange, 15);
  }
}
</style>
